import React from 'react';
import styles from './TabPanel.module.css';

/**
 * TabPanel — contenedor de una pestaña activa con su header y contenido.
 *
 * @param {object}    tab       - Objeto de la pestaña { fn, description }
 * @param {ReactNode} children  - Contenido del ejercicio
 */
function TabPanel({ tab, children }) {
  return (
    <section className={styles.panel}>
      <div className={styles.panelHeader}>
        <code className={styles.fn}>{tab.fn}</code>
        <p className={styles.description}>{tab.description}</p>
      </div>
      {children}
    </section>
  );
}

export default TabPanel;
